import React from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';
import cn from 'classnames';

const propTypes = {
  as: PropTypes.any,
  className: PropTypes.string,
  children: PropTypes.any,
  bare: PropTypes.bool,
  block: PropTypes.bool,
  error: PropTypes.string,
  full: PropTypes.bool,
  max: PropTypes.number,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  status: PropTypes.object,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
};
const defaultProps = {
  as: 'input',
  type: 'text',
  required: false,
};

const EditField = ({
  as: Component,
  className,
  children,
  bare,
  block,
  error,
  full,
  max,
  name,
  label,
  placeholder,
  onBlur,
  onChange,
  required,
  status,
  tip,
  type,
  value,
  ...props
}) => {
  const errorMsg = path(['errors', name], status) || error;
  const labelStyle = cn('col-form-label', { 'col-md-3': !block, 'col-md-12': block });
  const wrapperStyle = cn({
    'col-md-12': block,
    'col-md-7': !block && !full,
    'col-md-9': !block && full,
  });
  const inputStyle = cn({ 'form-control': !bare });

  return (
    <div className={cn('form-group row', className, { 'pb-2': tip })}>
      {label && (
        <label htmlFor={name} className={labelStyle}>
          {label}
        </label>
      )}
      <div className={wrapperStyle}>
        <div className={cn({ 'input-group': children })}>
          <Component
            id={name}
            type={type}
            className={inputStyle}
            placeholder={placeholder}
            name={name}
            value={value}
            required={required}
            onBlur={onBlur}
            onChange={onChange}
            {...props}
          />
          {children && <div className="input-group-append">{children}</div>}
        </div>
        {tip && <div className="tip">{tip}</div>}
        {errorMsg && (
          <span className="invalid-feedback">
            <strong>{errorMsg}</strong>
          </span>
        )}
        {max && (
          <span className="input-counter float-right">
            {value.length} / {max} characters
          </span>
        )}
      </div>
    </div>
  );
};

EditField.propTypes = propTypes;
EditField.defaultProps = defaultProps;

export default EditField;
